// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608212032/js/" + chunkId + "." + {"44":"b3600cd8","225":"050eba58","481":"598e8f57","486":"3b12374b","770":"2a260a33"}[chunkId] + ".0.9838724832202691.chunk.js";
};